import {
    useEffect,
    type FC
} from "react";
import type INotificationIndicatorProps from "./type";
import {
    getBadgeIndicatorPropsFromNotificationIndicator
} from "./util";
import {
    warnOnce
} from "../../utils/development";
import Badge from "../badge";

const NotificationIndicator: FC<INotificationIndicatorProps> = (props) => {
    const {
        children,
        ...badgeProps
    } = getBadgeIndicatorPropsFromNotificationIndicator({
        props
    });

    useEffect(() => {
        warnOnce({
            message: "NotificationIndicator is deprecated and will be removed in the next major version. Use Badge.Indicator instead."
        });
    }, []);

    useEffect(() => {
        if(props.location?.right === undefined && props.location?.left === undefined) {
            return;
        }

        warnOnce({
            message: "NotificationIndicator: \"location.left\" and \"location.right\" are deprecated and will be removed in the next major version. Use \"location.start\" and \"location.end\" instead."
        });
    }, [
        props.location?.right,
        props.location?.left
    ]);

    return <Badge.Indicator
        {...badgeProps}
    >
        {children}
    </Badge.Indicator>;
};
export default NotificationIndicator;
